import type { AllKeyOf, Nullable } from 'chaika-common-types';

import { translate } from '@chaika/i18n/helper';
import { OptionType } from '@components/Select';
import { makeOptionType } from '@utils/makeOptionTypes';
import { store } from '@store';

import { useAccountantLegalEntities } from '../../../hooks/useAccountantLegalEntities';

export enum ReportType {
    RenderedServices = 'Оказанные услуги',
    Payments = 'Платежи',
    RenderedServicesChanges = 'Изменения оказанных услуг',
}

export function getReportTypeTransation(type: ReportType): string {
    const StatusDic: AllKeyOf<ReportType> = {
        [ReportType.RenderedServices]: translate('renderedServices'),
        [ReportType.Payments]: translate('paymentsOtherVersion'),
        [ReportType.RenderedServicesChanges]: translate('rsChanges'),
    };
    return StatusDic[type];
}

export function useOptions(selectedLegalEntity: Nullable<OptionType<string>>) {
    const { legalEntityBranchList, organizationList } = store;
    const legalEntities = useAccountantLegalEntities();

    function getLegalEntityOptions(): OptionType[] {
        return makeOptionType(legalEntities);
    }

    function getOrganizationOptions(): OptionType[] {
        const organizationsOptions: OptionType[] = [];

        if (selectedLegalEntity?.value) {
            const legalEntityOrganizationIDS = legalEntityBranchList.getLegalEntityOrganizationIds(
                selectedLegalEntity.value,
            );
            const organizations = legalEntityOrganizationIDS.map(item => organizationList.getExisting(item));

            organizationsOptions.push(...makeOptionType(organizations));
        }

        return organizationsOptions;
    }

    function getReportTypeOptions(): OptionType[] {
        return [
            {
                label: getReportTypeTransation(ReportType.RenderedServices),
                value: ReportType.RenderedServices,
            },
            {
                label: getReportTypeTransation(ReportType.Payments),
                value: ReportType.Payments,
            },
            {
                label: getReportTypeTransation(ReportType.RenderedServicesChanges),
                value: ReportType.RenderedServicesChanges,
            },
        ];
    }

    return {
        reportTypeOptions: getReportTypeOptions(),
        legalEntityOptions: getLegalEntityOptions(),
        organizationOptions: getOrganizationOptions(),
    };
}
